import { kExtraSmallButtonStandardSize } from "../constants";
import { QPlus10Button } from "../CoreApp/QPlus10Button";

export function AddPlus10Control(x, y, plus, hoverCode, cmdCode, panel) {
  var z = new QPlus10Button();
  z.PositionElement(x, y);
  z.SizeElement(kExtraSmallButtonStandardSize, kExtraSmallButtonStandardSize);
  z.SetHoverCode(hoverCode);
  z.SetCmdCode(cmdCode);
  panel.PushElement(z);
  return z;
}
